import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box, InputBase, FormControl, IconButton, Grid, List,
    Button, Dialog, DialogContent, DialogActions, Typography, ListItem,
    Divider, RadioGroup, Radio, FormControlLabel, CircularProgress, Collapse
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { Search, Close } from '@material-ui/icons';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import CustomMessagePoper from './custom-message-popover';
import UploadFilesPopup from '../file-management/upload-files-popup';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import Checkbox from '../checkbox';
import icAttachment from '../assets/icons/ic_attachment.png';
import icAttachSelected from '../assets/icons/ic_attach_selected.png';
import AttachmentItem from './table-attachment-item';

import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks';
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow';
import Field from '../CustomizedUIs/CustomTextFiled';
import CustomTextField from '../CustomizedUIs/CustomTextFieldWithFontSize';
import DateTimePicker from '../common/date-time-picker';
import SelectBoxTemplateList from '../common/select-template-list';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import icSearch from '../assets/icons/grayscale-3-search.png';
import SelectBoxScheduleTemplate from '../common/select-box-schedule-template';
import {
    FONT_SIZE, RECEIVER_TYPE, MESSAGES_TYPE, DEFAULT_MESSAGE_TEMPLATE, SCHEDULE_TYPE, RECURRENCE,
    trimSubjectStr, getListIdsSaveAsDraft, getTemplateInterval, FONT_SIZE_LABEL
} from '../utils';
import { listChange } from './actions';
import { useDispatch } from 'react-redux';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import SelectBoxInterval from '../common/select-box-interval';
import TransferList from './TransferList';
import { cloneDeep } from 'lodash'
import TextButton from '../CustomizedUIs/TextButton';

const useStyles = makeStyles((theme) => ({
    list: {
        height: 255,
        backgroundColor: theme.palette.background.paper,
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '2.8px !important',
            height: "5px",
            borderRadius: "4px",
            backgroundColor: ' #c1e5fa'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 10px white',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1e5fa',
            borderRadius: '10px'
        }
    },
    dialogCloseBtn: {
        // backgroundColor: theme.palette.common.white,
        marginLeft: 7,
        width: "25px",
        height: "25px",
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",

    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        maxWidth: '650px',
        backgroundColor: theme.palette.background.default
    },
    inputMulti: {
        width: '525px',
        borderRadius: '2px',
    },
    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '16px',
        top: '20px'
    },
    addRecipientsText: {
        paddingBottom: '2px',
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: " #4f5064",
    },
    switchAddAll: {
        width: 140,
        height: 30,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginLeft: '24px'
    },
    saveDraft: {
        width: ' 111px',
        height: '36px',
        borderRadius: '10px',
        border: ' solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
    },
    send: {
        marginRight: '30px',
        width: '138px',
        height: '36px',
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
    },
    divider: {
        marginTop: '14px'
    },
    switchText: {
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: " 0.36px",
        color: "#4f5064",
    },
    borderSearch: {
        borderRadius: "8.1px",
        border: "solid 0.8px #f1f2f4",
        backgroundColor: "#f7f7f7",

    },
    textSearch: {
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c",
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    iconSearch: {
        border: "solid 0px #b4b5bd",
    },
    clusterText: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 2.18,
        letterSpacing: "0.11px",
        color: "#4f5064",
    },
    btnClose: {
        fontFamily: " UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        color: "#4f5064",
    },
    Title: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        paddingBottom: "30px",
        marginTop: -10
    },
    titleRadio: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
    },
    TextDateTime: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.85,
        letterSpacing: " 0.13px",
        color: "#4f5064",
    },
    titleDateTime: {
        fontFamily: " UniviaPro",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.36,
        letterSpacing: "normal",
        color: "#88898c",
    },
    TitileDyslexieFont: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: " 0.36px",
        color: "4f5064",
    },

    btnSave: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: ' 11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: theme.palette.primary.main,
    },
    btnSend: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: ' 11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: '#ffffff',
    },
    NoRecipientsSelected: {
        paddingBottom: '2px',
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#88898c",
    },
}));

const categoriesDeleted = [];
let draft;
let dialogContent;
const DialogEditDraftScheduleMessage = ({ open, onClose, data, thread, messageId, isDraft }) => {
    const translate = useTranslate();
    const classes = useStyles();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();

    // STATE REGION
    const [loadingDialog, setLoadingDialog] = useState(false);
    const [listTemplates, setListTemplates] = useState([]);
    const [template, setTemplate] = useState("");
    const [templateID, setTemplateID] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [loadingDraft, setLoadingDraft] = useState(false);
    const [filter, setFilter] = useState("");
    const [checkedSwitch, setCheckedSwitch] = useState(false);
    const [start, setStart] = useState(true);
    const [oldLeft, setOldLeft] = useState([]);
    const [left, setLeft] = useState([]);
    const [leftFilter, setLeftFilter] = useState([]);
    const [right, setRight] = useState([]);
    const [individuals, setIndividuals] = useState([]);
    const [cloneIndividuals, setCloneIndividuals] = useState([]);
    const [receiver, setReceiver] = useState("");
    const [openTemplate, setOpenTemplate] = useState(false);
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [valuePriority, setValuePriority] = useState(0);
    const [valueMessageType, setValueMessageType] = useState(0);
    const [valueScheduleRadio, setValueScheduleRadio] = useState(0);
    const [valueExpirationRadio, setValueExpirationRadio] = useState(0);
    const [dateSchedule, setDateSchedule] = useState(new Date());
    const [dateExpiration, setDateExpiration] = useState(new Date());
    const [fontSize, setFontSize] = useState(FONT_SIZE_LABEL.MEDIUM);
    const [categories, setCategories] = useState([]);
    const [isAttachOpen, setAttachOpen] = useState(false);
    const [isDyslexieEnable, setDyslexieEnable] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [selectedScheduleTemplate, setSelectedScheduleTemplate] = useState(null);
    const [listScheduleTemplate, setListScheduleTemplate] = useState([]);
    const [selectedRecurrence, setSelectedRecurrence] = useState(null);
    const list = useSelector((state) => state.list);
    const dispatch = useDispatch();
    // END STATE REGION

    const popupState = usePopupState({ variant: 'popper', popupId: 'attachments' });
    const [error, setError] = useState({
        isError: true,
        message: ""
    });
    const [textValue, setTextValue] = useState({
        subject: '',
        content: '',
    });

    const onChangeFilter = (event) => {
        setFilter(event.target.value)
        searchRecipient(event.target.value)
    }

    const searchRecipient = (value) => {
        if (receiver === 'Individuals') {
            setLeft(leftFilter.reduce((arr, currentItem) => {
                if (currentItem.name.includes(value)) {
                    arr.push(currentItem)
                }
                else {
                    if (!value.includes(' ')) {
                        const items = currentItem.rooms.filter(item => item.number === parseInt(value) || item.name.toLowerCase().includes(value.toLowerCase()));
                        if (items.length > 0)
                            arr.push({ name: currentItem.name, rooms: items });
                    }
                }
                return arr
            }, []))
            if (right.length > 0 && value === '') {
                for (let i = 0; i < right.length; i++) {
                    for (let j = 0; j < right[i].rooms.length; j++) {
                        leftFilter.map(item => {
                            item.rooms.map((room, index) => {
                                right[i].rooms.map(rm => {
                                    if (rm.uniqueRoomName === room.uniqueRoomName) {
                                        item.rooms.splice(index, 1)
                                    }
                                })
                            })
                        })
                    }
                }
                leftFilter.map((item, index) => {
                    if (item.rooms.length === 0)
                        leftFilter.splice(index, 1)
                })
                setLeft(leftFilter)
            }
        }
        else {
            setLeft(leftFilter.filter(item => {
                if (item.name.toUpperCase().includes(value.toUpperCase()))
                    return item
                else
                    return null
            }))
            if (right.length > 0 && value === '') {
                if (receiver !== RECEIVER_TYPE.CLUSTER) {
                    right.map(itemRight => {
                        leftFilter.map((itemLeft, index) => {
                            if (itemLeft.name === itemRight.name) {
                                leftFilter.splice(index, 1)
                            }
                        })
                    })
                    setLeft(leftFilter)
                }
                else {
                    right.map(itemRight => {
                        leftFilter.map((itemLeft, index) => {
                            if (itemLeft.uniqueName === itemRight.uniqueName) {
                                leftFilter.splice(index, 1)
                            }
                        })
                    })
                    setLeft(leftFilter)
                }
            }
        }
    }

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        if (prop === 'content') {
            if (value.length === 0) {
                setError(
                    value.length === 0 ? {
                        isError: true, message: translate('pos.messages.required')
                    } : {
                        isError: false, message: ''
                    }
                )
            }
            else {
                setError(
                    {
                        isError: false,
                        message: ''
                    }
                )
            }
        }
    }

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    useEffect(() => {
        getListTemplates();
        getListScheduleTemplates();
    }, []);

    useEffect(() => {
        if (filter === '')
            setLeft(individuals)
    }, [filter]);

    // useEffect(() => {
    //     if (left.length === 0) {
    //         setCheckedSwitch(true)
    //     }
    //     else {
    //         setCheckedSwitch(false)
    //     }
    // }, [left, right]);

    const getListTemplates = () => {
        dataProvider('GET_LIST', 'message-templates', {
            filter: {
            },
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            data.unshift(DEFAULT_MESSAGE_TEMPLATE);
            setListTemplates(data);
        }).catch(error => {
            // TODO: Should show error message
            console.error('getTemplates error:', error)
        });
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleToggleAll = (items) => () => {
        if (receiver === 'Individuals') {
            var tempData = cloneIndividuals
            if (checkedSwitch === false) {
                setCheckedSwitch(true);
                setLeft([])
                setLeftFilter([]);
                setRight(tempData)
            }
            else {
                setCheckedSwitch(false);
                setLeft(tempData)
                setLeftFilter(tempData)
                setRight([])
                setFilter('')
            }
        }
        else {
            setCheckedSwitch(!checkedSwitch);
            setStart(false)
        }
    };

    const onUploadFilesSuccess = (categories) => {
        setAttachOpen(false);
        getCategory(categories);
        popupState.close();
    }

    const getCategory = (newCategories) => {
        if (newCategories) {
            setCategories([...categories, ...newCategories]);
        }
    }

    const renameCategory = (category) => {
        if (category) {
            let newCategories = categories.map(item => {
                if (item.id === category.id) {
                    item = category;
                }
                return item;
            })
            setCategories(newCategories);
        }
    }

    const handleRadioPriorityChange = (event) => {
        setValuePriority(parseInt(event.target.value));
    };

    const handleRadioMessageTypeChange = (event) => {
        setValueMessageType(parseInt(event.target.value));
    };

    const handleRadioScheduleChange = (event) => {
        setValueScheduleRadio(parseInt(event.target.value));
    };

    const handleRadioExpirationChange = (event) => {
        setValueExpirationRadio(parseInt(event.target.value));
    };

    const removeCategories = () => {
        categories.forEach(item => {
            dataProvider('DELETE', 'category', { id: item.id }).then((data) => {
            }).catch(error => {
                console.log('onDeleteOne error:', error);
            });
        })
    }

    const clearDialog = () => {
        setLeft([])
        setLeftFilter([])
        setRight([])
        setIndividuals([])
        setFilter("")
        setCategories([])
        setCheckedSwitch(false)
        setStart(true)
        setOpenPopper(false)
        setTemplate("")
        setOpenTemplate(false)
        setValuePriority(0)
        setValueMessageType(0)
        setValueScheduleRadio(0)
        setValueExpirationRadio(0)
        setTextValue({
            subject: '',
            content: '',
        })
        setDateSchedule(new Date())
        setDateExpiration(new Date())
        setDyslexieEnable(false)
        setError({
            isError: false,
            message: ""
        });
        setSelectedScheduleTemplate(null);
        setSelectedRecurrence(null);
        setFontSize(FONT_SIZE_LABEL.MEDIUM);
    }

    const handleClose = () => {
        // removeCategories()
        clearDialog()
        onClose();
    }

    const onChangeRecurrence = (value) => {
        if (value.name === 'None')
            setSelectedRecurrence(null)
        else
            setSelectedRecurrence(value)
    }

    const onChangeScheduleTemplate = (value) => {
        setSelectedScheduleTemplate(value);
        if (value.scheduleMessages.length > 0) {
            const firstTemplate = value.scheduleMessages[0];
            setTextValue({
                subject: firstTemplate.subject,
                content: firstTemplate.message,
            });
        }
    }

    const autoHideErrorMessage = () => {
        setTimeout(() => {
            setErrorMsg('');
        }, 6000);
    }

    const sendImmediately = () => {
        const expiration = valueExpirationRadio === 1 ? dateExpiration.getTime() : 0;
        var trimText = textValue.content.trim()
        if (textValue.subject === "") {
            var text = ""
            for (let i = 0; i < trimText.length; i++) {
                if (i > 50)
                    break
                else {
                    text += trimText.charAt(i)
                }
            }
            var newSubject = ""
            for (let i = 0; i < text.length; i++) {
                if (!(text.charAt(i).match(/\n/))) {
                    newSubject += text.charAt(i)
                }
                else
                    break
            }
            textValue.subject = `${newSubject}...`
        }
        const data = {
            subject: textValue.subject,
            message: textValue.content,
            fontSize: fontSize,
            priorityType: valuePriority,
            messageType: valueMessageType,
            scheduleType: valueScheduleRadio,
            expiration: expiration,
            dyslexie: isDyslexieEnable,
            receiverType: draft.receiverType, // TODO HardCode
            ids: getListIdsSaveAsDraft(draft.receiverType, right),
            files: categories.map(c => c.id),
            thread: thread ? thread : -1,
        };

        dataProvider('CREATE', 'message', { data }).then(() => {
            // Remove this draft message
            dataProvider('DELETE', 'message/draft', { id: messageId }).then(() => {
                onClose(MESSAGES_TYPE.SENT);
                clearDialog();
                setLoading(false);
            });
        }).catch(error => {
            console.log('Create message error:', error);
            setLoading(false);
        });
    }

    const sendSchedule = () => {
        if (valueScheduleRadio === 1 && new Date(dateSchedule) < Date.now()) {
            setErrorMsg(translate(`pos.common.scheduleExpired`))
            dialogContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            autoHideErrorMessage();
        }
        else if (valueExpirationRadio !== 0 && new Date(dateExpiration) < new Date(dateSchedule)) {
            setErrorMsg(translate(`pos.messages.errorExpiration`));
            dialogContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            autoHideErrorMessage();
        }
        else {
            if (valueExpirationRadio !== 0 && new Date(dateExpiration) < Date.now()) {
                setErrorMsg(translate(`pos.messages.errorExpiration`));
                dialogContent.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
                autoHideErrorMessage();
            }
            else {
                const data = getBodyToCreateDraftOrSchedule(false);

                setLoadingDraft(true);
                dataProvider('UPDATE', 'message/draft', { id: draft.id, data }).then(() => {
                    onClose(MESSAGES_TYPE.SCHEDULED);
                    clearDialog();
                    setLoadingDraft(false)
                }).catch(error => {
                    setLoadingDraft(false);
                    dialogContent.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                    setErrorMsg(translate(error.message));
                    autoHideErrorMessage();
                });
            }
        }
    }

    const sendScheduleTemplate = () => {
        if (valueExpirationRadio !== 0 && new Date(dateExpiration) < Date.now()) {
            setErrorMsg(translate(`pos.messages.errorExpiration`));
            dialogContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            autoHideErrorMessage();
        }
        else {
            const expiration = valueExpirationRadio === 1 ? dateExpiration.getTime() : 0;
            const data = {
                subject: textValue.subject,
                message: textValue.content,
                fontSize: fontSize,
                priorityType: valuePriority,
                messageType: valueMessageType,
                receiverType: receiver,
                expiration: expiration,
                scheduleTemplateId: selectedScheduleTemplate.id,
                dyslexie: isDyslexieEnable,
                ids: getListIdsSaveAsDraft(receiver, right),
                files: categories.map(c => c.id),
                thread: thread ? thread : -1,
            };

            setLoading(true);
            dataProvider('CREATE', 'messages/create-list-schedule', {
                data
            }).then(res => {
                // TODO: Delete draft/schedule
                dataProvider('DELETE', 'messages/outbox-draft-scheduled', {
                    id: draft.id
                }).then(({ data }) => {
                    setLoading(false);
                    onClose(MESSAGES_TYPE.SCHEDULED);
                }).catch(error => console.error('DELETE DRAFT/SCHEDULE ERROR:', error));
            }).catch(error => {
                console.error('CREATE LIST SCHEDULE ALARM ERROR:', error);
            });
        }
    }

    const handleSendMessage = () => {
        switch (valueScheduleRadio) {
            case SCHEDULE_TYPE.IMMEDIATELY:
                sendImmediately();
                break;
            case SCHEDULE_TYPE.OTHER:
                sendSchedule();
                break;
            case SCHEDULE_TYPE.SCHEDULE_TEMPLATE:
                sendScheduleTemplate();
                break;
            default:
                break;
        }
    }

    const getBodyToCreateDraftOrSchedule = (isDraft = true) => {
        const expiration = valueExpirationRadio === 1 ? dateExpiration.getTime() : 0;
        const data = {
            subject: trimSubjectStr(textValue.subject, textValue.content, isDraft),
            message: textValue.content,
            template: templateID,
            fontSize: fontSize,
            priorityType: valuePriority,
            messageType: valueMessageType,
            scheduleType: valueScheduleRadio,
            interval: valueScheduleRadio === 1 ? (selectedRecurrence ? selectedRecurrence.value : 'none') : 'none',
            expiration: expiration,
            dyslexie: isDyslexieEnable,
            receiverType: draft.receiverType,
            ids: JSON.stringify(getListIdsSaveAsDraft(draft.receiverType, right)),
            files: JSON.stringify(categories.map(c => c.id)),
            thread: thread ? thread : -1,
            isDraft
        };

        switch (valueScheduleRadio) {
            case SCHEDULE_TYPE.IMMEDIATELY:
                data.schedule = 0;
                data.scheduleTemplate = null;
                break;
            case SCHEDULE_TYPE.OTHER:
                data.schedule = dateSchedule.getTime();
                data.scheduleTemplate = null;
                break;
            case SCHEDULE_TYPE.SCHEDULE_TEMPLATE:
                data.schedule = 0;
                data.scheduleTemplate = selectedScheduleTemplate.id;
                break;
        }

        return data;
    }

    const handleSaveDraftMessage = () => {
        setLoadingDraft(true)
        const data = getBodyToCreateDraftOrSchedule();

        // Handle delete files
        categoriesDeleted.forEach(categoryId => {
            dataProvider('DELETE', 'category', { id: categoryId }).then((res) => {
                console.log('DELETE category:', res);
            }).catch(error => {
                console.log('onDeleteOne error:', error);
            });
        });

        dataProvider('UPDATE', 'message/draft', {
            id: messageId,
            data
        }).then(() => {
            onClose(MESSAGES_TYPE.DRAFT);
            clearDialog()
            setLoadingDraft(false)
        }).catch(response => {
            setLoadingDraft(false)
        });
    }

    const getListScheduleTemplates = () => {
        setLoading(true)
        dataProvider('GET_LIST', "schedule-template", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            setListScheduleTemplate(data)
            setLoading(false)
        }).catch(error => {
            console.error('getListScheduleTemplates:', error);
            setLoading(false)
        });
    }

    const onChangeTemplate = (item) => {
        setOpenTemplate(false);
        if (item.name === "None") {
            setTemplate("");
            setTemplateID(null);
            setFontSize(FONT_SIZE_LABEL.MEDIUM);
        } else {
            setTemplate(item.name);
            setTemplateID(item.id);
            setFontSize(item.fontSize);
        }
        setTextValue({
            subject: item.subject,
            content: item.message,
        });
        setValuePriority(item.priorityType);
        setValueMessageType(item.messageType);

        setValueScheduleRadio(item.scheduleType);
        if (item.scheduleType === 1) {
            setDateSchedule(new Date(item.schedule));
        } else {
            setDateSchedule(new Date());
        }
        if (item.scheduleType === 2) {
            listScheduleTemplate.map(value => {
                if (value.id === item.scheduleTemplate)
                    setSelectedScheduleTemplate(value)
            })
        }

        if (item.expiration === 0) {
            setValueExpirationRadio(0);
        } else {
            setValueExpirationRadio(1);
            setDateExpiration(new Date(item.expiration));
        }
        setDyslexieEnable(item.dyslexie);
        setSelectedRecurrence(getTemplateInterval(item.interval))
    }

    const handleClickOpenTemplate = () => {
        setOpenTemplate(!openTemplate)
    }


    const onDeleteOne = (id) => {
        const newCategories = categories.filter(item => item.id !== id);
        setCategories(newCategories);
        categoriesDeleted.push(id);
    }

    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    const handleTransferList = (value, style) => () => {
        if (style === "left") {
            left.map((item, itemIndex) => {
                if (value.cluster.name === item.name) {
                    const index = item.rooms.findIndex(element => element.id === value.id);
                    if (item.rooms.length > 0)
                        item.rooms.splice(index, 1)
                }
                if (item.rooms.length === 0) {
                    left.splice(itemIndex, 1)
                }
            })
            individuals.map((item, itemIndex) => {
                if (value.cluster.name === item.name) {
                    const index = item.rooms.findIndex(element => element.id === value.id);
                    if (item.rooms.length > 0)
                        item.rooms.splice(index, 1)
                }
                if (item.rooms.length === 0) {
                    individuals.splice(itemIndex, 1)
                }
            })
            if (right.length === 0) {
                right.push({
                    name: value.cluster.name,
                    rooms: [value]
                })
            }
            else {
                var checkExist = true
                for (let i = 0; i < right.length; i++) {
                    if (value.cluster.name === right[i].rooms[0].cluster.name && value.cluster.entity === right[i].rooms[0].cluster.entity
                        && value.cluster.group === right[i].rooms[0].cluster.group) {
                        checkExist = true
                        break
                    }
                    else {
                        checkExist = false
                    }
                }
                if (checkExist) {
                    for (let i = 0; i < right.length; i++) {
                        if (value.cluster.name === right[i].rooms[0].cluster.name && value.cluster.entity === right[i].rooms[0].cluster.entity
                            && value.cluster.group === right[i].rooms[0].cluster.group) {
                            right[i].rooms.push(value)
                        }
                    }
                }
                else {
                    right.push({
                        name: value.cluster.name,
                        rooms: [value]
                    })
                }
            }
            setLeftFilter(individuals)
            if (list === false) {
                dispatch(listChange(true))
            }
            else {
                dispatch(listChange(false))
            }
            if (left.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0 && filter === "")
                setCheckedSwitch(true)
            if (individuals.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0)
                setFilter('')
            setLoading(false)
        }
        else {
            setCheckedSwitch(false)
            right.map((item, itemIndex) => {
                if (value.cluster.name === item.name) {
                    const index = item.rooms.findIndex(element => element.id === value.id);
                    if (item.rooms.length > 0)
                        item.rooms.splice(index, 1)
                }
                if (item.rooms.length === 0) {
                    right.splice(itemIndex, 1)
                }
            })
            if (left.length === 0 && filter === "") {
                left.push({
                    name: value.cluster.name,
                    rooms: [value]
                })
            }
            else {
                var checkExist = true
                for (let i = 0; i < left.length; i++) {
                    if (value.cluster.name === left[i].rooms[0].cluster.name && value.cluster.entity === left[i].rooms[0].cluster.entity
                        && value.cluster.group === left[i].rooms[0].cluster.group) {
                        checkExist = true
                        break
                    }
                    else {
                        checkExist = false
                    }
                }
                if (checkExist) {
                    for (let i = 0; i < left.length; i++) {
                        if (value.cluster.name === left[i].rooms[0].cluster.name && value.cluster.entity === left[i].rooms[0].cluster.entity
                            && value.cluster.group === left[i].rooms[0].cluster.group) {
                            for (let j = 0; j < left[i].rooms.length; j++) {
                                if (left[i].rooms[j].id !== value.id) {
                                    left[i].rooms.push(value)
                                    break
                                }
                                else {
                                    break
                                }
                            }
                        }
                    }
                }
                else {
                    left.push({
                        name: value.cluster.name,
                        rooms: [value]
                    })
                }
            }
            if (individuals.length === 0 && filter === "") {
                individuals.push({
                    name: value.cluster.name,
                    rooms: [value]
                })
            }
            if (individuals.length > 0 && filter !== "") {
                var checkExistIndividual = true
                for (let i = 0; i < individuals.length; i++) {
                    if (value.cluster.name === individuals[i].rooms[0].cluster.name && value.cluster.entity === individuals[i].rooms[0].cluster.entity
                        && value.cluster.group === individuals[i].rooms[0].cluster.group) {
                        checkExistIndividual = true
                        break
                    }
                    else {
                        checkExistIndividual = false
                    }
                }
                if (checkExistIndividual) {
                    for (let i = 0; i < individuals.length; i++) {
                        if (value.cluster.name === individuals[i].rooms[0].cluster.name && value.cluster.entity === individuals[i].rooms[0].cluster.entity
                            && value.cluster.group === individuals[i].rooms[0].cluster.group) {
                            for (let j = 0; j < individuals[i].rooms.length; j++) {
                                if (individuals[i].rooms[j].id !== value.id) {
                                    individuals[i].rooms.push(value)
                                    break
                                }
                                else {
                                    break
                                }
                            }
                        }
                    }
                }
                else {
                    individuals.push({
                        name: value.cluster.name,
                        rooms: [value]
                    })
                }
            }
            if (list === false) {
                dispatch(listChange(true))
            }
            else {
                dispatch(listChange(false))
            }
            if (right.length === 0) {
                setFilter('')
                setLoading(false)
            }
        }
    }

    const handleToggleAllCluster = (value, style) => () => {
        if (list === false) {
            dispatch(listChange(true))
        }
        else {
            dispatch(listChange(false))
        }
        if (style === 'left') {
            if (right.length === 0) {
                individuals.map((item, index) => {
                    if (item.name === value.name) {
                        right.push(item)
                        individuals.splice(index, 1)
                    }
                })
                left.map((item, index) => {
                    if (item.name === value.name)
                        left.splice(index, 1)
                })
                setLeftFilter(individuals)
            }
            else {
                var checkExist = true
                for (let i = 0; i < right.length; i++) {
                    var checkBreak = false
                    for (let j = 0; j < value.rooms.length; j++) {
                        if (value.rooms[j].cluster.name === right[i].rooms[0].cluster.name && value.rooms[j].cluster.entity === right[i].rooms[0].cluster.entity
                            && value.rooms[j].cluster.group === right[i].rooms[0].cluster.group) {
                            checkExist = true
                            checkBreak = true
                            break
                        }
                        else {
                            checkExist = false
                        }
                    }
                    if (checkBreak)
                        break
                }
                if (checkExist) {
                    for (let i = 0; i < right.length; i++) {
                        value.rooms.map(item => {
                            if (item.cluster.name === right[i].rooms[0].cluster.name && item.cluster.entity === right[i].rooms[0].cluster.entity
                                && item.cluster.group === right[i].rooms[0].cluster.group) {
                                right[i].rooms.push(item)
                            }
                        })
                    }
                }
                else {
                    // right.push(value)
                    individuals.map((item, index) => {
                        if (item.name === value.name) {
                            right.push(item)
                            individuals.splice(index, 1)
                        }
                    })
                }
                left.map((item, index) => {
                    if (item.name === value.name)
                        left.splice(index, 1)
                })
                setLeftFilter(individuals)
            }
            if (left.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0 && filter === "")
                setCheckedSwitch(true)
            if (individuals.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0)
                setFilter('')
        }
        else {
            setCheckedSwitch(false)
            if (left.length === 0) {
                individuals.push(value)
                setLeft(individuals)
                setFilter('')
                // left.push(value)
                right.map((item, index) => {
                    if (item.name === value.name)
                        right.splice(index, 1)
                })
            }
            else {
                var checkExist = true
                for (let i = 0; i < left.length; i++) {
                    var checkBreak = false
                    for (let j = 0; j < value.rooms.length; j++) {
                        if (value.rooms[j].cluster.name === left[i].rooms[0].cluster.name && value.rooms[j].cluster.entity === left[i].rooms[0].cluster.entity
                            && value.rooms[j].cluster.group === left[i].rooms[0].cluster.group) {
                            checkExist = true
                            checkBreak = true
                            break
                        }
                        else {
                            checkExist = false
                        }
                    }
                    if (checkBreak)
                        break
                }
                if (checkExist) {
                    for (let i = 0; i < left.length; i++) {
                        value.rooms.map(item => {
                            if (item.cluster.name === left[i].rooms[0].cluster.name && item.cluster.entity === left[i].rooms[0].cluster.entity
                                && item.cluster.group === left[i].rooms[0].cluster.group) {
                                left[i].rooms.push(item)
                            }
                        })
                    }
                }
                else {
                    left.push(value)
                }
                right.map((item, index) => {
                    if (item.name === value.name)
                        right.splice(index, 1)
                })
            }
        }
    }

    const disableSendButton = () => {
        if (textValue.content === '' || right.length === 0) return true;
        if (valueScheduleRadio === SCHEDULE_TYPE.SCHEDULE_TEMPLATE && !selectedScheduleTemplate) return true;
        if (!permissions.functionAction.find(value => value.function === 'Messages' && value.isUpdate)) return true;
        return false;
    }

    const disableDraftButton = () => {
        if (!permissions.functionAction.find(value => value.function === 'Messages' && value.isUpdate)) return true;
        if (!isDraft) return true;
        return false;
    }

    const getText = () => {
        if (!receiver) return '';
        switch (receiver) {
            case RECEIVER_TYPE.ENTITY:
                return translate(`resources.messages.Entity`)
            case RECEIVER_TYPE.GROUP:
                return translate(`resources.messages.Group`)
            case RECEIVER_TYPE.CLUSTER:
                return translate(`resources.messages.Cluster`)
            case RECEIVER_TYPE.INDIVIDUALS:
                return translate(`resources.messages.Room`)
            case RECEIVER_TYPE.USER:
                return translate(`resources.messages.User`)
        }
    }

    const customList = (items, style, filter) => {
        return (
            <List className={classes.list} component="div" disablePadding >
                {style === "left" &&
                    <Box padding="8px">
                        <Box width='100%' display='flex' className={classes.borderSearch} >
                            < img src={icSearch} className={classes.iconSearch} width={15} height={15} style={{ margin: 'auto 2px auto 5px' }}></img>
                            <InputBase
                                fullWidth={true}
                                placeholder={translate(`resources.alarm.search`) + getText().toLowerCase()}
                                inputProps={{
                                    'aria-label': 'search',
                                    className: classes.textSearch
                                }}
                                onChange={onChangeFilter}
                                value={filter}
                                style={{ width: '180px' }}
                            />
                        </Box>
                    </Box>
                }
                {style === "left" && <Divider />}
                {
                    items.map((value, idx) => {
                        return (
                            < Box style={{ marginLeft: 10 }} key={idx}>
                                <Typography onClick={handleToggleAllCluster(value, style)}>{value.name}</Typography>
                                {value.rooms.map((element, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <Box display="flex" alignItems="center" key={element.id} onClick={handleTransferList(element, style)}>
                                                <Checkbox
                                                    checked={style === 'right'}
                                                    color='primary'
                                                />
                                                <Typography className={classes.clusterText} >{element.name}</Typography>
                                            </Box>
                                            <Divider />
                                        </React.Fragment>
                                    )
                                })}
                            </Box>
                        )
                    })
                }
            </List>
        )
    };

    const getMessageDetail = () => {
        setLoadingDialog(true);
        dataProvider('GET_ONE', 'message/draft', {
            id: messageId
        }).then(({ data }) => {
            draft = data;
            draft.ids = JSON.parse(data.ids);
            setReceiver(draft.receiverType)
            getListRecipient();
            listTemplates.map(item => {
                if (data.template && data.template === item.id) {
                    setTemplate(item.name)
                    setTemplateID(item.id)
                }
            })

            setLoadingDialog(false);
            // TODO: Set value for dialog
            setTextValue({
                subject: data.subject,
                content: data.message
            });

            setValuePriority(data.priorityType);
            setValueMessageType(data.messageType);

            setValueScheduleRadio(data.scheduleType);
            if (data.scheduleType === SCHEDULE_TYPE.OTHER) {
                setDateSchedule(new Date(data.schedule));
                setSelectedRecurrence(getTemplateInterval(data.interval))
            } else if (data.scheduleType === SCHEDULE_TYPE.SCHEDULE_TEMPLATE) {
                setSelectedScheduleTemplate(data.scheduleTemplate);
            }

            if (data.expiration === 0) {
                setValueExpirationRadio(0);
            } else {
                setValueExpirationRadio(1);
                setDateExpiration(new Date(data.expiration));
            }

            setFontSize(data.fontSize);
            setDyslexieEnable(data.dyslexie);

            setCategories(data.categories);
        }).catch(error => {
            console.error('GET MESSAGE ERROR:', error);
        });
    }

    const getGroups = () => {
        setLoadingList(true)
        const { ids } = draft;
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {},
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            const leftGroups = data.countResult.groups;
            leftGroups.map((item, index) => {
                item.id = index
            })
            const cloneLeftGroups = cloneDeep(leftGroups)
            setOldLeft(cloneLeftGroups)
            const rightGroups = [];
            for (let i = 0; i < ids.length; i++) {
                const leftGroupIdx = leftGroups.findIndex(item => (item.entity + ' - ' + item.name) === ids[i]);
                if (leftGroupIdx > -1) {
                    // Found it
                    rightGroups.push(leftGroups[leftGroupIdx]);
                    leftGroups.splice(leftGroupIdx, 1);
                }
            }
            if (leftGroups.length === 0)
                setCheckedSwitch(true)
            else
                setCheckedSwitch(false)
            setLeft(leftGroups);
            setRight(rightGroups);
            setLoadingList(false)
        }).catch(error => console.error('getGroups error:', error));
    }

    const getEntities = () => {
        setLoadingList(true)
        const ids = draft.ids;
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {},
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            const leftEntities = data.countResult.entities;
            leftEntities.map((item, index) => {
                item.id = index
            })
            const cloneLeftEntities = cloneDeep(leftEntities)
            setOldLeft(cloneLeftEntities)
            const rightEntities = [];
            for (let i = 0; i < ids.length; i++) {
                const leftEntityIdx = leftEntities.findIndex(item => item.name === ids[i]);
                if (leftEntityIdx > -1) {
                    // Found it
                    rightEntities.push(leftEntities[leftEntityIdx]);
                    leftEntities.splice(leftEntityIdx, 1);
                }
            }
            if (leftEntities.length === 0)
                setCheckedSwitch(true)
            else
                setCheckedSwitch(false)
            setLeft(leftEntities);
            setRight(rightEntities);
            setLoadingList(false)
        }).catch(error => console.error('getEntities error:', error));
    }

    const getClusters = () => {
        setLoadingList(true)
        const ids = draft.ids;
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {},
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            const leftClusters = data.cluster;
            const cloneLeftCluster = cloneDeep(leftClusters)
            setOldLeft(cloneLeftCluster)
            const rightClusters = [];
            for (let i = 0; i < ids.length; i++) {
                const leftClusterIdx = leftClusters.findIndex(item => item.id === ids[i]);
                if (leftClusterIdx > -1) {
                    // Found it
                    rightClusters.push(leftClusters[leftClusterIdx]);
                    leftClusters.splice(leftClusterIdx, 1);
                }
            }
            if (leftClusters.length === 0)
                setCheckedSwitch(true)
            else
                setCheckedSwitch(false)
            setLeft(leftClusters);
            setRight(rightClusters);
            setLoadingList(false)
        }).catch(error => console.error('getClusters error:', error));
    }

    const getListUser = () => {
        setLoadingList(true)
        const ids = draft.ids;
        dataProvider('GET_LIST', "room/assign", {
            filter,
            pagination: {},
            sort: {
                field: 'id',
                order: 'ASC'
            },
        }).then(({ data }) => {
            const leftUsers = data.listUser.map(value => ({
                ...value,
                name: `${value.username} - ${value.firstName} ${value.lastName}`
            }));
            const cloneLeftUser = cloneDeep(leftUsers)
            setOldLeft(cloneLeftUser)
            const rightUsers = [];
            for (let i = 0; i < ids.length; i++) {
                const leftUserIdx = leftUsers.findIndex(item => item.id === ids[i]);
                if (leftUserIdx > -1) {
                    // Found it
                    rightUsers.push(leftUsers[leftUserIdx]);
                    leftUsers.splice(leftUserIdx, 1);
                }
            }
            if (leftUsers.length === 0)
                setCheckedSwitch(true)
            else
                setCheckedSwitch(false)
            setLeft(leftUsers);
            setRight(rightUsers);
            setLoadingList(false)
        }).catch((error) => {
            setError(error)
            setLoading(false)
        });
    }

    const getListIndividual = () => {
        const ids = draft.ids;
        dataProvider('GET_LIST', "room/listbyid", {
            filter: {
                ids: ids,
                messages: true
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        })
            .then(({ data }) => {
                setLeft(data.listLeft)
                setRight(data.right)
                setIndividuals(data.listIndividual)
                const cloneListRoom = cloneDeep(data.listIndividual)
                setCloneIndividuals(cloneListRoom)
                setLoading(false)
            })
            .catch(error => {
                // TODO: Should show error message
                setLoading(false)
            })
    }

    const getListRecipient = () => {
        switch (draft.receiverType) {
            case RECEIVER_TYPE.ENTITY:
                getEntities();
                break;
            case RECEIVER_TYPE.GROUP:
                getGroups();
                break;
            case RECEIVER_TYPE.CLUSTER:
                getClusters();
                break;
            case RECEIVER_TYPE.INDIVIDUALS:
                getListIndividual();
                // setOpenSendMessage(true)
                break;
            case RECEIVER_TYPE.USER:
                getListUser();
                break;
        }
    }

    const onEnter = () => {
        getMessageDetail();
    }

    if (!loaded) return null
    return (
        <Dialog onEnter={onEnter} open={open} scroll='paper' onClose={handleClose} classes={{ paper: classes.dialogPaper }} fullWidth={true} disableEnforceFocus disableBackdropClick>
            <Box mx={5} mt={3} ref={node => dialogContent = node}>
                <Box display='flex' justifyContent='flex-end' alignItems='center'>
                    <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
                    <IconButton size='small' className={classes.dialogCloseBtn} onClick={handleClose}>
                        <Close color='primary' />
                    </IconButton>
                </Box>
                <Typography className={classes.Title}>{isDraft ? translate(`resources.messages.editDraftMessage`) : translate(`resources.messages.editScheduleMessage`)}</Typography>
            </Box>
            {
                (loadingDialog || loadingList) ? <Box style={{ height: '74vh' }}><Loading /></Box> : (
                    <div>
                        <DialogContent style={{ padding: '8px 40px' }}>
                            <Collapse in={errorMsg.length > 0}>
                                <Alert severity="error">{errorMsg}</Alert>
                            </Collapse>
                            <Box display="flex" mx={2.5}>
                                <Box flex="1" display="flex" alignItems="flex-end">
                                    <Typography className={classes.addRecipientsText}>{translate(`resources.messages.addrecipients`)}</Typography>
                                    <Box px={1} className={classes.switchAddAll}>
                                        <Typography className={classes.switchText}>
                                            {translate(`resources.messages.addallrecipients`) + getText()}
                                        </Typography>
                                        <GreenSwitch size='small' style={{ color: 'white' }} checked={checkedSwitch} onChange={handleToggleAll(left)} />
                                    </Box>
                                </Box>
                                <Box style={{ width: 20 }} />
                                <Box flex="1" display="flex" alignItems="flex-end">
                                    <Typography className={classes.addRecipientsText}>{translate(`resources.messages.selectrecipients`)}</Typography>
                                </Box>
                            </Box>
                            {receiver === 'Individuals' ? (
                                <Box display="flex" mx={2.5} mt={1}>
                                    <Box flex="1">
                                        {customList(left, "left", filter)}
                                    </Box>
                                    <Box style={{ width: 20 }} />
                                    {
                                        right.length > 0 ?
                                            <Box flex="1">{customList(right, "right")}</Box> :
                                            <Box flex="1">
                                                <List className={classes.list} component="div" disablePadding >
                                                    <Typography style={{ textAlign: 'center', paddingTop: "120px" }} className={classes.NoRecipientsSelected}>{translate(`resources.alarm.Nodata`)}</Typography>
                                                </List>
                                            </Box>
                                    }
                                </Box>
                            ) : (
                                <Box display="flex" mx={2.5} mt={1}>
                                    <TransferList
                                        setLeft={setLeft}
                                        left={left}
                                        setRight={setRight}
                                        right={right}
                                        receiver={receiver}
                                        checkedSwitch={checkedSwitch}
                                        setCheckedSwitch={setCheckedSwitch}
                                        start={start}
                                        oldLeft={oldLeft}
                                    />
                                </Box>
                            )
                            }

                            <Box mt={4} mx={2.5}>
                                <SelectBox label={translate(`pos.messages.template`)} alignItems="center" open={openTemplate} value={template} handleClick={handleClickOpenTemplate}>
                                    <SelectBoxTemplateList list={listTemplates} onChangeTemplate={onChangeTemplate} />
                                </SelectBox>
                            </Box>
                            <Box mt={4} mx={2.5}>
                                <Field
                                    id="filled-basic"
                                    label={translate(`pos.messages.subject`)}
                                    value={textValue.subject}
                                    onChange={textOnChange('subject')}
                                    style={{ width: 525 }}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.messages.subject`)}
                                        content={translate(`pos.messages.constentSubject`)}
                                        icon={<b>?</b>}
                                    />}
                                />
                            </Box>
                            <Box mt={4} mx={2.5}>
                                <FormControl component="fieldset">
                                    <Grid container spacing={1} alignItems="center" >
                                        <Grid item>
                                            <Typography className={classes.titleRadio}>{translate(`resources.messages.priority`)}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <CustomMessagePoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`resources.messages.priority`)}
                                                content={translate(`resources.messages.prioritymessage`)}
                                                icon={<b>?</b>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <RadioGroup row aria-label="position" name="position" value={valuePriority} onChange={handleRadioPriorityChange} >
                                        <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.critical`)} />
                                        <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Normal`)} style={{ marginLeft: '92px' }} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <Divider className={classes.divider} />
                            <Box mt={2.5} mx={2.5}>
                                <FormControl component="fieldset">
                                    <Grid container spacing={1} alignItems="center" >
                                        <Grid item>
                                            <Typography className={classes.titleRadio}> {translate(`resources.messages.messagetype`)}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <CustomMessagePoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.messages.type`)}
                                                content={translate(`pos.messages.constentType`)}
                                                icon={<b>?</b>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <RadioGroup row aria-label="position" name="position" value={valueMessageType} onChange={handleRadioMessageTypeChange}>
                                        <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.popup`)} />
                                        <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Notification`)} style={{ marginLeft: '90px' }} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <Divider className={classes.divider} />
                            <Box mt={2.5} mx={2.5}>
                                <FormControl component="fieldset">
                                    <Grid container spacing={1} alignItems="center" >
                                        <Grid item>
                                            <Typography className={classes.titleRadio} color="textPrimary" >{translate(`resources.messages.Schedule`)}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <CustomMessagePoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.messages.schedule`)}
                                                content={translate(`pos.messages.constentSchedule`)}
                                                icon={<b>?</b>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <RadioGroup row aria-label="position" name="position" value={valueScheduleRadio} onChange={handleRadioScheduleChange}>
                                        <FormControlLabel value={SCHEDULE_TYPE.IMMEDIATELY} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Immediately`)} />
                                        <FormControlLabel value={SCHEDULE_TYPE.OTHER} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Other`)} style={{ marginLeft: '63px' }} />
                                        <FormControlLabel value={SCHEDULE_TYPE.SCHEDULE_TEMPLATE} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.ScheduleTemplate`)} style={{ marginLeft: '70px' }} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <SelectBoxInterval
                                open={valueScheduleRadio === SCHEDULE_TYPE.OTHER}
                                recurrence={selectedRecurrence}
                                onSelect={onChangeRecurrence}
                            />
                            <DateTimePicker
                                open={valueScheduleRadio === SCHEDULE_TYPE.OTHER}
                                date={dateSchedule}
                                setDate={setDateSchedule}
                                style='message'
                                minDate={new Date()}
                                title={translate(`resources.reviews.fields.date`)}
                            />
                            <SelectBoxScheduleTemplate
                                open={valueScheduleRadio === SCHEDULE_TYPE.SCHEDULE_TEMPLATE}
                                scheduleTemplate={selectedScheduleTemplate}
                                onSelect={onChangeScheduleTemplate}
                            />
                            <Divider className={classes.divider} />
                            <Box mt={2.5} mx={2.5}>
                                <FormControl component="fieldset">
                                    <Grid container spacing={1} alignItems="center" >
                                        <Grid item>
                                            <Typography className={classes.titleRadio}>{translate(`pos.messages.expiration`)}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <CustomMessagePoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.messages.expiration`)}
                                                content={translate(`pos.messages.constentExpiration`)}
                                                icon={<b>?</b>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <RadioGroup row aria-label="position" name="position" value={valueExpirationRadio} onChange={handleRadioExpirationChange}>
                                        <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.none`)} />
                                        <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.daytime`)} style={{ marginLeft: '100px' }} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <DateTimePicker
                                open={valueExpirationRadio === 1}
                                date={dateExpiration}
                                setDate={setDateExpiration}
                                style='message'
                                minDate={new Date()}
                                title={translate(`resources.reviews.fields.date`)}
                            />
                            <Divider className={classes.divider} />
                            <Box mt={4.9} mx={2.5}>
                                <CustomTextField
                                    onBlur={() => {
                                        validate('content', textValue.content)
                                    }}
                                    className={classes.inputMulti}
                                    id="textfield-message"
                                    multiline
                                    rows={4}
                                    value={textValue.content}
                                    onChange={textOnChange('content')}
                                    placeholder={`${translate(`pos.messages.placeholder`)} *`}
                                    error={error.message !== "" && error.isError}
                                    helperText={error.message}
                                    isDyslexieEnable={isDyslexieEnable}
                                    fontSize={fontSize}
                                    setFontSize={setFontSize}
                                    endDom={
                                        <Box>
                                            <Box className={classes.inputPopper}>
                                                <CustomPoper
                                                    open={openPoper}
                                                    anchorEl={anchorEl}
                                                    handleClick={handleClickOpenPoper}
                                                    handleClose={handleClosePoper}
                                                    title={translate(`pos.messages.constent`)}
                                                    content={translate(`pos.messages.constentContent`)}
                                                    icon={<b>?</b>}
                                                />
                                            </Box>
                                        </Box>
                                    }
                                />
                            </Box>
                            <Box mt={3} mx={2.5} display='flex' alignItems='center'>
                                <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="flex-start">
                                    <Grid item >
                                        <Box display='flex' borderRadius={4} alignItems='center'>
                                            <IconButton
                                                variant="outlined"
                                                color='primary'
                                                style={{ marginRight: '10px', padding: 'unset' }}
                                                {...bindToggle(popupState)}
                                            >
                                                {
                                                    isAttachOpen ?
                                                        <img src={icAttachSelected} width={27} /> : <img src={icAttachment} width={27} />
                                                }
                                            </IconButton>
                                            <CustomPopoverArrow
                                                zIndex={1500}
                                                popupState={popupState}
                                                placement='left-end'
                                            >
                                                <UploadFilesPopup
                                                    onUploadFilesSuccess={onUploadFilesSuccess}
                                                    parentId={8}        // default attachments folder id
                                                    close={() => {
                                                        setAttachOpen(false);
                                                        popupState.close();
                                                    }}
                                                    message
                                                    getCategory={getCategory}
                                                    acttachmentStyle={{
                                                        maxHeight: 260,
                                                        overflow: 'auto'
                                                    }}
                                                />
                                            </CustomPopoverArrow>
                                            <Typography className={classes.titleRadio} >{translate('pos.messages.attachBtn')}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box display='flex' borderRadius={4} bgcolor='background.paper' py={0.4} pr={1} pl={2} alignItems='center'>
                                            <Box flexGrow={1}>
                                                <Typography className={classes.TitileDyslexieFont} style={{ marginRight: 23 }}>{translate(`pos.messages.dyslexieFont`).toUpperCase()}</Typography>
                                            </Box>
                                            <GreenSwitch checked={isDyslexieEnable} onChange={() => setDyslexieEnable(!isDyslexieEnable)}
                                                size='small' style={{ color: 'white' }}></GreenSwitch>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box mt={2} mx={2.5} style={{ maxHeight: "60vh", overflow: 'auto', }}>
                                {
                                    categories.map(item =>
                                        <AttachmentItem
                                            renameCategory={renameCategory}
                                            item={item}
                                            key={item.id + ''}
                                            onDeleteOne={onDeleteOne}
                                            handleDownload={() => { }}
                                            isDownload={false}
                                        />
                                    )
                                }
                            </Box>
                        </DialogContent>
                    </div>
                )
            }
            {!loadingDialog &&
                <DialogActions className={classes.dialogActions}>
                    <TextButton mr={2} style={{ marginTop: "1em" }} onClick={handleClose} />

                    <Button disabled={disableDraftButton()} onClick={handleSaveDraftMessage} className={classes.saveDraft} color="primary">
                        {loadingDraft ? (
                            <CircularProgress
                                size={25}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            <Typography className={classes.btnSave}>  {translate('pos.messages.save')}</Typography>
                        }
                    </Button>

                    <Button
                        disabled={disableSendButton()}
                        variant="contained"
                        className={classes.send}
                        size="large"
                        color="primary"
                        onClick={handleSendMessage}
                    >
                        {loading ? (
                            <CircularProgress
                                size={25}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            <Typography className={classes.btnSend} style={{ whiteSpace: 'pre' }}>{translate('pos.messages.send')}</Typography>
                        }
                    </Button>
                </DialogActions>
            }
        </Dialog>
    )
}

DialogEditDraftScheduleMessage.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    messageId: PropTypes.number,
    isDraft: PropTypes.bool.isRequired,
};

export default DialogEditDraftScheduleMessage;
